// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from 'firebase/app';
import * as constants from './constants';

// Add the Firebase services that you want to use
import 'firebase/auth';
import 'firebase/firestore';

var firebaseConfig = {
  apiKey: constants.apiKey,
  authDomain: constants.authDomain,
  databaseURL: constants.databaseURL,
  projectId: constants.projectId,
  storageBucket: constants.storageBucket,
  messagingSenderId: constants.messagingSenderId,
  appId: constants.appId,
  measurementId: constants.measurementId,
};

let db;
let auth;

if (!firebase.apps.length) {
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  auth = firebase.auth();

  db = firebase.firestore();

  // if (constants.env === 'development') {
  //   auth.useEmulator("http://localhost:9099");
  //   db.useEmulator("localhost", 8080);
  // }
}

export { firebase as default, db, auth };
